import { createRouter, createWebHistory } from 'vue-router';
import Home from './views/Home';

const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: '/', redirect: '/flink' },
    { path: '/flink', component: Home }
  ],
});

export default router;
